import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axiosInstance from '../../../api/axiosInstance';
import endpoints from '../../../api/endpoints';
import { RootState } from '../../../redux/store';


interface CommandeData {
  numeroClient: string;
 
}

export interface Commande {
  NombreArticles: number | string
  NumeroCommande: any
  StatutSolde: any
  StatutLivraison: any
  StatutFacturation: any
  STATUSCOMMANDE: string
  StatutFinal: any
  NumeroClient: string
  NumeroRepresentant: any
  DateCommande: string
  MontantTTC: number
  IsExistsPyramide: boolean
  NomClient: string
}

interface ApiState {
  data: Commande[] | null;
  loading: boolean;
  error: string | null;
  dataPreCommande: Commande[] | null;
  loadingPreCommande: boolean;
  errorPreCommande: string | null;
}

const initialState: ApiState = {
  data: null,
  loading: false,
  error: null,
  dataPreCommande: null,
  loadingPreCommande: false,
  errorPreCommande: null,
};


export const postCommandes = createAsyncThunk(
  'api/postCommandes',
  async (data: CommandeData, { getState }) => {
    const state: RootState = getState() as RootState;
    const language = state.languageSlice.language;
    const token = state.authSlice.token;
   
    const response = await axiosInstance.post(endpoints.commandes.commandesParClient, data, {
      headers: {
        'Accept-Language': language,
        "Authorization": `Bearer ${token}`, 
      },
    });
    return response.data as Commande[];
  }
);

export const getCommandes = createAsyncThunk(
  'api/getCommandes',
  async (_, { getState }) => {
    const state: RootState = getState() as RootState;
    const language = state.languageSlice.language;
    const token = state.authSlice.token;
   
    const response = await axiosInstance.get(endpoints.commandes.commandesParRepresentant
    );

    return response.data as Commande[];
  }
);


export const getPreCommandes = createAsyncThunk(
  'api/getPreCommandes',
  async (_, { getState }) => {
    const state: RootState = getState() as RootState;
    const language = state.languageSlice.language;
    const token = state.authSlice.token;
   
    const response = await axiosInstance.get(endpoints.commandes.precommandeList);
  
    return response.data as Commande[];
  }
);

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postCommandes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postCommandes.fulfilled, (state, action: PayloadAction<Commande[]>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postCommandes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to post data';
      })
      .addCase(getCommandes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCommandes.fulfilled, (state, action: PayloadAction<Commande[]>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getCommandes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to post data';
      })
      .addCase(getPreCommandes.pending, (state) => {
        state.loadingPreCommande = true;
        state.errorPreCommande = null;
      })
      .addCase(getPreCommandes.fulfilled, (state, action: PayloadAction<Commande[]>) => {
        state.loadingPreCommande = false;
        state.dataPreCommande = action.payload;
      })
      .addCase(getPreCommandes.rejected, (state, action) => {
        state.loadingPreCommande = false;
        state.errorPreCommande = action.error.message || 'Failed to post data';
      });
  },
});

export default orderSlice.reducer;
